import React from 'react';
import type { SxProps } from '@mui/material';

import SearchView from 'shared/components/Search';

import useDispatch from 'shared/hooks/useDispatch';
import useSelector from 'shared/hooks/useSelector';

import createSearchSlice from './createSearchSlice';

type SearchSliceFactoryProps = {
  prefix: string;
};
type SearchProps = {
  sx?: SxProps;
};

export default function searchSliceFactory(props: SearchSliceFactoryProps) {
  const { prefix } = props;

  const searchSlice = createSearchSlice({
    prefix,
  });

  const useSearchQuery = () => {
    return useSelector(searchSlice.selectors.selectSearchQuery);
  };

  const Search = (props: SearchProps) => {
    const { sx } = props;

    const dispatch = useDispatch();
    const searchQuery = useSearchQuery();

    const changeSearchQuery = React.useCallback(
      (query: string) => {
        dispatch(searchSlice.actions.setSearchQuery(query));
      },
      [dispatch]
    );

    const handleChangeSearchQuery = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        changeSearchQuery(event.target.value);
      },
      [changeSearchQuery]
    );

    // const handleClearSearchQuery = React.useCallback(() => {
    //   changeSearchQuery('');
    // }, [changeSearchQuery]);

    return (
      <SearchView
        debounce
        placeholder="Hae"
        value={searchQuery}
        onChange={handleChangeSearchQuery}
        rootSx={sx}
      />
    );
  };

  return { searchSlice, Search, useSearchQuery };
}
